import { Component, Inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatRadioModule } from '@angular/material/radio';
import get from 'lodash-es/get';
import { ExportFileFormat, ExportRange } from 'app/layout/export-overlay/tasks/core/export-task.enum';

@Component({
  selector: 'app-order-customer-export-dialog',
  templateUrl: './export-dialog.component.html',
  styleUrls: ['./export-dialog.component.scss'],
  imports: [MatDialogModule, MatButtonModule, MatRadioModule, FormsModule],
  standalone: true,
})
export class ExportDialogComponent {
  title: string ;
  selectedFormat = 'xlsx';
  selectedRange = 'current-page';

  constructor(
    private ref: MatDialogRef<ExportDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { title: string },
  ) {
    this.title = get(data, 'title', '');
  }

  private getFileFormat() {
    if (this.selectedFormat === 'xlsx') return ExportFileFormat.Excel;
    if (this.selectedFormat === 'csv') return ExportFileFormat.CSV;
    return ExportFileFormat.JSON;
  }

  private getRange() {
    if (this.selectedRange === 'current-page') return ExportRange.CurrentPage;
    return ExportRange.AllPages;
  }

  onExportButtonPressed() {
    this.ref.close({
      format: this.getFileFormat(),
      range: this.getRange(),
    });
  }
}
